module.exports = __webpack_public_path__ + "img/image158.e0cdb95a.jpg";